const removeFullPageLoader = () => {
  const loader = document.getElementById("page-loader");
  loader?.remove?.();
};

export default removeFullPageLoader;
